<template lang="pug">
	//- История сообщений текущего чата, предложение исправить ошибку превью и индикаторы ожидания
	.ai-chat-history
		AIAgentEmptyChat(v-if="!messages.length && !thinking && !transcribing && !previewError")
		.ai-chat-message(v-for="message in messages" :key="message.id" :class="[message.role, getMessageType(message)]")
			AIAgentMessageService(v-if="isServiceMessage(message)" :message="message" :type="getMessageType(message)")
			AIAgentMessageConfirm(v-else-if="getMessageType(message) === 'confirm'" :message="message" :confirming="confirmingMessageId === message.id" v-on:answer="(...args) => $emit('answer-confirmation', ...args)")
			AIAgentMessageCodeChanged(v-else-if="getMessageType(message) === 'code-changed'" :message="message")
			AIAgentMessageAssetCreated(v-else-if="getMessageType(message) === 'asset-created'" :message="message" v-on:thumbnail-loaded="onThumbnailLoaded($event)")
			AIAgentMessageAttachments(v-else-if="getMessageType(message) === 'attachments'" :message="message" v-on:thumbnail-loaded="onThumbnailLoaded($event)")
			AIAgentMessageText(v-else :message="message")
		AIAgentPreviewError(v-if="previewError" :error="previewError" :thinking="thinking" v-on:fix="$emit('fix-preview-error')" v-on:dismiss="$emit('dismiss-preview-error')")
		AIAgentIndicators(:chat="chat" :thinking="thinking" :stopping="stopping" :transcribing="transcribing" v-on:stop="$emit('stop')")
</template>

<script>
	import { AIAgent } 					from './../../services/AIAgent'

	// Компонент текстового сообщения импортируется первым: его стили (оформление сообщения по роли) должны подключаться раньше стилей
	// остальных типов сообщений, которые переопределяют фон и рамку с той же специфичностью селекторов
	import AIAgentMessageText			from './AIAgent.MessageText'
	import AIAgentEmptyChat				from './AIAgent.EmptyChat'
	import AIAgentMessageService		from './AIAgent.MessageService'
	import AIAgentMessageConfirm		from './AIAgent.MessageConfirm'
	import AIAgentMessageCodeChanged	from './AIAgent.MessageCodeChanged'
	import AIAgentMessageAssetCreated	from './AIAgent.MessageAssetCreated'
	import AIAgentMessageAttachments	from './AIAgent.MessageAttachments'
	import AIAgentPreviewError			from './AIAgent.PreviewError'
	import AIAgentIndicators			from './AIAgent.Indicators'

	// Служебные сообщения агента, показываемые компактной строкой
	const SERVICE_MESSAGE_TYPES = ['tool', 'stats', 'voice'];

	export default {
		name: "AIAgentHistory",
		// previewError - ошибка превью выбранной версии (null, если предложение исправить ошибку не показывается),
		// confirmingMessageId - id запроса подтверждения, ответ на который отправлен на сервер
		props: ['chat', 'messages', 'thinking', 'stopping', 'transcribing', 'previewError', 'confirmingMessageId'],
		components: {
			AIAgentEmptyChat,
			AIAgentMessageService,
			AIAgentMessageConfirm,
			AIAgentMessageCodeChanged,
			AIAgentMessageAssetCreated,
			AIAgentMessageAttachments,
			AIAgentMessageText,
			AIAgentPreviewError,
			AIAgentIndicators
		},
		methods: {
			getMessageType(message) {

				return AIAgent.getMessageType(message);

			},
			isServiceMessage(message) {

				return _.includes(SERVICE_MESSAGE_TYPES, this.getMessageType(message));

			},
			// Миниатюра загружается после прокрутки истории - если это последнее сообщение, прокручиваем ещё раз, чтобы миниатюра была видна целиком
			onThumbnailLoaded(message) {

				if (_.last(this.messages)?.id === message.id) this.scrollToBottom();

			},
			// Вызывается и компонентом чата (новые сообщения, индикаторы, ошибка превью)
			scrollToBottom() {

				this.$el.scrollTop = this.$el.scrollHeight;

			}
		}
	}
</script>

<style lang="sass">

	.ai-chat
		.ai-chat-history
			flex: 1 1 auto
			min-height: 0
			overflow-y: auto
			overflow-x: hidden
			padding: 10px 15px
			user-select: text

			&::-webkit-scrollbar
				width: 4px
			&::-webkit-scrollbar-thumb
				background-color: #3f454b
				border-radius: 10px
			&::-webkit-scrollbar-track
				background-color: #ADB6BF66

</style>
